import React, { PureComponent } from 'react';
import {
  Select
} from 'antd';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setFilter } from '../../../actions';

import styles from './Aff.module.css';
import {
  getURLParams
} from '../../../helpers';

const { Option } = Select;

class Aff extends PureComponent {
  componentDidMount () {
    const param = getURLParams(window.location);
    this.props.setFilter({
      ...this.props.filters,
      aff: param.aff ? param.aff : ''
    });
  };

  render() {
    const defaultOption = 'All';
    const param = getURLParams(window.location);
    const value = param.aff ? param.aff : defaultOption;
    const {
      affList,
      qualityList,
      handleSelect,
    } = this.props;

    const listItems = affList.length > 0 && affList.map(({ aff, isActive, rowId }) => {
      const optionStyle = {
        color: !isActive ? '#f5222d' : 'inherit'
      };

      return (
        <Option
          key={rowId}
          style={optionStyle}
          value={aff === 'All' ? '' : aff}
        >
          {aff} {!isActive ? '(not active)' : ''}
        </Option>
      );
    });

    const slicedAffList = [...affList.slice(1)];
    const qList = slicedAffList.length > 0 && slicedAffList.map(({ aff, isActive, rowId }) => {
      const optionStyle = {
        color: !isActive ? '#f5222d' : 'inherit'
      };

      return (
        <Option
          key={rowId}
          style={optionStyle}
          value={aff === 'All' ? '' : aff}
        >
          {aff} {!isActive ? '(not active)' : ''}
        </Option>
      );
    });

    return (
      <div className={styles.aff}>
        {qualityList ? (
          slicedAffList.length === 0 ? (
            <p className={styles['no-feeds']}>No Feeds</p>
          ) : (
            <>
              <span className={styles.label}>Feeds:</span>
              <Select
                defaultValue={slicedAffList[0] && slicedAffList[0].aff}
                onChange={handleSelect}
                className={styles.control}
              >
                {qList}
              </Select>
            </>
          )
        ) : (
          <>
            <span className={styles.label}>Feeds:</span>
            <Select
              defaultValue={value}
              onChange={handleSelect}
              className={styles.control}
            >
              {listItems}
            </Select>
          </>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  filters: state.filters.filters,
  affList: state.user.payload.affList,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setFilter,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Aff);
